import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Api } from '../api/api';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';

/*
  Generated class for the ProfileProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ProfileProvider {
  constructor(public http: HttpClient, private api: Api) {}

  getInfoOnEvent(event, user): Observable<any> {
    return Observable.fromPromise(
      this.api.getNoSessionHeaders('events/getUserProfileOnEvent', {
        eventUuid: event,
        userUuid: user,
      })
    ).mergeMap(res => {
      return res;
    });
  }
  getUser(userId: string): Observable<any> {
    return this.api.post('user/findUser', { user: userId }).map(res => {
      return res;
    });
  }

  getUserInfoForEvent(eventUuid: string): Observable<any> {
    return this.api.get('user/getUserInfoForEvent', { eventUuid: eventUuid }).map(res => {
        return res;
      });
  }

  updateUser(user: any): Observable<any> {
    return this.api.post('user/updateUser', user).map(res => {
      return res;
    });
  }

  getInterests(): Observable<any> {
    return this.api.post('user/getInterests', {}).map(res => {
      return res;
    });
  }

  addInterest(tag: string): Observable<any> {
    return this.api.post('user/addInterest', { tag: tag }).map(res => {
      return res;
    });
  }

  removeInterest(id: number): Observable<any> {
    return this.api.post('user/removeInterest', { id: id }).map(res => {
      return res;
    });
  }

  changePassword(
    currentPassword: string,
    newPassword: string
  ): Observable<any> {
    return this.api
      .post('user/changePassword', {
        currentPassword: currentPassword,
        newPassword: newPassword,
      })
      .map(res => {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/profile/profile.ts